// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2SuAY","head":"ProcedureTableInfo_head__2dAYB"};